import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { EmployeeFormPage } from 'src/modules/automations/components/pages/employees/employee-form.page';
import { newEmployeeSearchSchema } from 'src/modules/automations/schemas/employees/employees.schema';

export const Route = createFileRoute('/employees/new')({
  component: NewEmployeeComponent,
  validateSearch: (search) => newEmployeeSearchSchema.parse(search),
});

function NewEmployeeComponent() {
  return (
    <AuthenticateRoute>
      <EmployeeFormPage isEdit={false} />
    </AuthenticateRoute>
  );
}
